import React from 'react'

export const DefaultContent = () => {
    return <React.Fragment />
}